import * as Yup from 'yup';
import { ILenderUtility } from '../../interfaces';

type Picked =
  | 'id'
  | 'name'
  | 'address'
  | 'city'
  | 'state'
  | 'code'
  | 'postCode'
  | 'contactPhone'
  | 'productCheckRequestPayee';

export type TLenderUtilityGeneralForm = Pick<ILenderUtility, Picked>;

export const lenderUtilityGeneralFormSchema = Yup.object().shape({
  name: Yup.string().required().nullable(),
  address: Yup.string().max(128).required().nullable(),
  city: Yup.string().max(128).required().nullable(),
  state: Yup.string().required().nullable(),
  code: Yup.string().required().nullable(),
  postCode: Yup.string().zipCode().required().nullable(),
  contactPhone: Yup.string().phone().nullable().required(),
  productCheckRequestPayee: Yup.object({
    id: Yup.string(),
    lenderId: Yup.string(),
    lenderName: Yup.string(),
    numericId: Yup.number(),
    payeeName: Yup.string().nullable(),
    payeeAddress: Yup.string().nullable(),
    payeeState: Yup.string().nullable(),
    payeeZip: Yup.number().nullable(),
  }),
});

export const stateRulesValidation = Yup.object().shape({
  state: Yup.string().required(),
  zips: Yup.string().nullable(),
  bureau: Yup.string().nullable(),
  daysToFirstPayment: Yup.number().min(0).integer().nullable(),
  loanAmount: Yup.number().min(0).nullable(),
  loanAmountOperator: Yup.string().when('loanAmount', {
    is: (loanAmount: number) => !!loanAmount,
    then: Yup.string().required().nullable(),
    otherwise: Yup.string().nullable(),
  }),
  apr: Yup.number().nullable(),
  aprOperator: Yup.string().when('apr', {
    is: (apr: number) => !!apr,
    then: Yup.string().required().nullable(),
    otherwise: Yup.string().nullable(),
  }),
  rate: Yup.number().nullable(),
  rateOperator: Yup.string().when('rate', {
    is: (rate: number) => !!rate,
    then: Yup.string().required().nullable(),
    otherwise: Yup.string().nullable(),
  }),
});
